const { wrapPageElement } = require("common/config/gatsby/browser")
const { wrapRootElement } = require("common/config/gatsby/browser")

exports.wrapPageElement = wrapPageElement
exports.wrapRootElement = wrapRootElement
